import { Theme } from '@mui/material'

const useStyles = {
  photoBtn: {
    textTransform: 'none',
  },
  pill: (theme: Theme) => ({
    display: 'flex',
    color: theme.palette.text.primary,
    border: '1px solid rgba(0, 0, 0, 0.05)',
    borderRadius: '50px',
    padding: theme.spacing(0, 1),
    whiteSpace: 'nowrap',
  }),
  thumbnail: {
    width: '98px',
    height: '98px',
    objectFit: 'cover' as const,
    borderRadius: '100px',
  },
}
export default useStyles
